export default __webpack_public_path__ + "static/media/check_ok.564c275d.svg";